// typings

import { create } from "zustand";

import { IMinhasTarefasState } from "@/store-zustand/admin/minhas-tarefas/index.d";

// criação da store com Zustand (minhas tarefas-admin)
export const useStoreZustandMinhasTarefas = create<IMinhasTarefasState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  minhasTarefas: [],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  idRemessa: null,
  isModalFinalizarTarefa: false,
  tarefa: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setMinhasTarefas: (minhasTarefas) => set({ minhasTarefas }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setIdRemessa: (idRemessa) => set({ idRemessa }),
  setIsModalFinalizarTarefa: (isModalFinalizarTarefa) => set({ isModalFinalizarTarefa }),
  setTarefa: (tarefa) => set({ tarefa }),
}));
